export const antdTheme = {
  token: {
    colorPrimary: '#80C0E9',
    colorInfo: '#80C0E9',
    colorSuccess: '#439167',
    colorError: '#B51010',
    colorWarning: '#E1B04F',

    colorBgBase: '#FFFFFF',
    colorBgContainer: '#FFFFFF',
    colorBgElevated: '#FFFFFF',
    colorBgLayout: '#FAFAFA',
    colorBgSpotlight: 'rgba(12, 87, 135, 0.9)',

    colorTextBase: '#333333',
    colorText: 'rgba(51, 51, 51, 0.88)',
    colorTextSecondary: 'rgba(107, 135, 153, 0.75)',
    colorTextTertiary: 'rgba(107, 135, 153, 0.55)',
    colorTextQuaternary: 'rgba(165, 163, 163, 0.45)',
    colorTextDisabled: '#A5A3A3',
    colorTextHeading: '#333333',
    colorTextDescription: '#6B8799',
    colorTextLabel: '#6B8799',
    colorTextPlaceholder: '#B5BCC1',

    colorLink: '#0C5787',
    colorLinkHover: '#80C0E9',
    colorLinkActive: '#0C5787',
    linkDecoration: 'none',
    linkHoverDecoration: 'none',

    colorBorder: '#E6EEF2',
    colorBorderSecondary: '#F0F0F0',
    colorSplit: 'rgba(230, 238, 242, 0.5)',

    fontFamily:
      "'PT Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    fontFamilyCode: "'PT Sans', 'SFMono-Regular', Consolas, monospace",
    fontSize: 14,
    fontSizeSM: 12,
    fontSizeLG: 16,
    fontSizeXL: 18,
    fontSizeHeading1: 32,
    fontSizeHeading2: 24,
    fontSizeHeading3: 20,
    fontSizeHeading4: 17,
    fontSizeHeading5: 14,
    lineHeight: 1.5714,
    lineHeightHeading1: 1.21,
    lineHeightHeading2: 1.27,
    lineHeightHeading3: 1.33,
    lineHeightHeading4: 1.4,
    lineHeightHeading5: 1.5,

    padding: 16,
    paddingXS: 8,
    paddingSM: 12,
    paddingLG: 24,
    paddingXL: 32,
    margin: 16,
    marginXS: 8,
    marginSM: 12,
    marginLG: 24,
    marginXL: 32,

    borderRadius: 8,
    borderRadiusSM: 5,
    borderRadiusLG: 10,
    borderRadiusXS: 4,

    controlHeight: 40,
    controlHeightSM: 32,
    controlHeightLG: 48,
    controlHeightXS: 24,

    boxShadow: '0 2px 8px rgba(51, 51, 51, 0.08)',
    boxShadowSecondary: '0 4px 12px rgba(0, 0, 0, 0.12)',
    boxShadowTertiary: '0 1px 4px rgba(0, 0, 0, 0.08)',

    wireframe: false,
    motion: true,
    zIndexBase: 0,
    zIndexPopupBase: 1000,
    lineWidth: 1,
    lineType: 'solid',
    opacityLoading: 0.65
  },

  components: {
    Button: {
      fontFamily: "'Oswald', sans-serif",
      fontWeight: 400,
      fontSize: 13,
      textTransform: 'uppercase',
      letterSpacing: '0.15em',
      controlHeight: 40,
      controlHeightSM: 32,
      controlHeightLG: 48,
      borderRadius: 8,
      paddingContentHorizontal: 24,

      colorPrimary: '#0C5787',
      colorPrimaryHover: '#80C0E9',
      colorPrimaryActive: '#0C5787',
      colorPrimaryBorder: '#0C5787',
      primaryColor: '#FFFFFF',
      colorPrimaryText: '#0C5787',
      primaryShadow: 'none',

      defaultBg: '#FFFFFF',
      defaultColor: '#6B8799',
      defaultBorderColor: '#E6EEF2',
      defaultHoverBg: '#FAFAFA',
      defaultHoverColor: '#80C0E9',
      defaultHoverBorderColor: '#80C0E9',
      defaultActiveBg: '#F0F0F0',
      defaultActiveBorderColor: '#80C0E9',

      colorDanger: '#B51010',
      dangerColor: '#FFFFFF',
      colorDangerHover: '#E92020',
      colorDangerActive: '#990D0D',

      colorLink: '#6B8799',
      colorLinkHover: '#80C0E9',
      colorLinkActive: '#0C5787',

      colorBgContainerDisabled: '#FAFAFA',
      colorTextDisabled: '#A5A3A3',
      borderColorDisabled: '#E6EEF2',

      contentFontSize: 13,
      contentFontSizeSM: 12,
      contentFontSizeLG: 14
    },

    Typography: {
      fontFamilyCode: "'PT Sans', monospace",
      titleMarginTop: 0,
      titleMarginBottom: '0.5em',
      fontSizeHeading1: 32,
      fontSizeHeading2: 24,
      fontSizeHeading3: 20,
      fontSizeHeading4: 17,
      fontSizeHeading5: 14,
      fontWeightStrong: 600,
      colorText: '#333333',
      colorTextHeading: '#333333',
      colorTextSecondary: '#6B8799',
      colorLink: '#0C5787',
      colorLinkHover: '#80C0E9',
      linkDecoration: 'underline',
      linkHoverDecoration: 'underline'
    },

    Form: {
      labelFontSize: 13,
      labelColor: '#6B8799',
      labelColonMarginInlineStart: 2,
      labelColonMarginInlineEnd: 8,
      itemMarginBottom: 17,
      verticalLabelPadding: '0 0 4px',
      verticalLabelMargin: 0,
      labelHeight: 32,
      labelRequiredMarkColor: '#B51010',
      labelFontFamily: "'Oswald', sans-serif",
      labelFontWeight: 400,
      labelTextTransform: 'uppercase',
      labelLetterSpacing: '0.15em'
    },

    Input: {
      colorText: '#0C5787',
      colorTextPlaceholder: '#B5BCC1',
      colorBgContainer: '#FFFFFF',
      colorBorder: '#E6EEF2',
      borderRadius: 8,
      controlHeight: 40,
      paddingBlock: 6,
      paddingInline: 10,

      hoverBorderColor: '#80C0E9',
      activeBorderColor: '#80C0E9',
      activeShadow: '0 0 0 2px rgba(128, 192, 233, 0.1)',
      errorActiveShadow: '0 0 0 2px rgba(181, 16, 16, 0.1)',
      warningActiveShadow: '0 0 0 2px rgba(225, 176, 79, 0.1)',

      colorErrorBorderHover: '#B51010',
      colorWarningBorderHover: '#E1B04F',

      addonBg: '#FAFAFA',

      colorBgContainerDisabled: '#FAFAFA',
      colorTextDisabled: '#A5A3A3'
    },

    InputNumber: {
      colorText: '#0C5787',
      colorTextPlaceholder: '#B5BCC1',
      colorBgContainer: '#FFFFFF',
      colorBorder: '#E6EEF2',
      borderRadius: 8,
      controlHeight: 40,
      paddingBlock: 4,
      paddingInline: 10,

      hoverBorderColor: '#80C0E9',
      activeBorderColor: '#80C0E9',
      activeShadow: '0 0 0 2px rgba(128, 192, 233, 0.1)',

      handleWidth: 18,
      handleFontSize: 12,
      handleBg: '#FFFFFF',
      handleBorderColor: '#E6EEF2',
      handleHoverColor: '#80C0E9',
      handleActiveBg: '#F0F0F0',

      colorBgContainerDisabled: '#FAFAFA'
    },

    Select: {
      colorText: '#0C5787',
      colorTextPlaceholder: '#B5BCC1',
      colorBgContainer: '#FFFFFF',
      colorBgElevated: '#FFFFFF',
      colorBorder: '#E6EEF2',
      borderRadius: 8,
      controlHeight: 40,

      optionSelectedBg: '#E6F4FF',
      optionSelectedColor: '#0C5787',
      optionActiveBg: '#F0F0F0',
      optionFontSize: 14,
      optionLineHeight: 1.5714,
      optionPadding: '8px 12px',

      multipleItemBg: '#F0F0F0',
      multipleItemBorderColor: 'transparent',
      multipleItemHeight: 28,

      hoverBorderColor: '#80C0E9',
      activeBorderColor: '#80C0E9',
      activeShadow: '0 0 0 2px rgba(128, 192, 233, 0.1)',

      clearBg: '#FFFFFF'
    },

    Switch: {
      colorPrimary: '#0C5787',
      colorPrimaryHover: '#80C0E9',
      colorTextQuaternary: '#B5BCC1',
      colorTextTertiary: '#A5A3A3',
      trackMinWidth: 50,
      trackMinWidthSM: 36,
      handleSize: 18,
      handleSizeSM: 14,
      innerMinMargin: 4,
      innerMaxMargin: 26,
      trackPadding: 2
    },

    Checkbox: {
      borderRadiusSM: 4,
      colorPrimary: '#80C0E9',
      colorPrimaryHover: '#0C5787',
      colorBgContainer: '#FFFFFF',
      colorBorder: '#E6EEF2',
      colorWhite: '#FFFFFF'
    },

    Radio: {
      borderRadius: 5,
      colorPrimary: '#80C0E9',
      colorBgContainer: '#FFFFFF',
      colorBorder: '#E6EEF2',

      buttonBg: '#FFFFFF',
      buttonCheckedBg: '#E6F4FF',
      buttonColor: '#6B8799',
      buttonSolidCheckedBg: '#0C5787',
      buttonSolidCheckedColor: '#FFFFFF',
      buttonSolidCheckedHoverBg: '#80C0E9',
      buttonPaddingInline: 16
    },

    DatePicker: {
      borderRadius: 8,
      controlHeight: 40,
      colorBgContainer: '#FFFFFF',
      colorBgElevated: '#FFFFFF',
      colorText: '#0C5787',
      colorTextHeading: '#333333',
      colorTextDisabled: '#A5A3A3',
      colorBorder: '#E6EEF2',

      cellHoverBg: '#F0F0F0',
      cellActiveWithRangeBg: '#E6F4FF',
      cellHoverWithRangeBg: '#F0F0F0',
      cellRangeBorderColor: '#80C0E9',
      cellBgDisabled: '#FAFAFA',
      cellHeight: 32,
      withoutTimeCellHeight: 40,

      cellBgToday: '#E6F4FF',
      colorPrimary: '#80C0E9',

      activeBorderColor: '#80C0E9',
      hoverBorderColor: '#80C0E9',
      activeShadow: '0 0 0 2px rgba(128, 192, 233, 0.1)'
    },

    Modal: {
      contentBg: '#FFFFFF',
      headerBg: 'transparent',
      footerBg: 'transparent',
      borderRadiusLG: 8,
      boxShadow: '0 12px 48px rgba(0, 0, 0, 0.15)',

      headerPadding: '16px 24px',
      bodyPadding: '24px',
      footerPadding: '12px 24px',

      titleFontSize: 20,
      titleLineHeight: 1.4,
      titleColor: '#0C5787',
      titleFontFamily: "'Oswald', sans-serif",
      titleFontWeight: 600,

      contentPadding: '24px',

      closeIconColor: '#6B8799',
      closeIconHoverColor: '#B51010'
    },

    Drawer: {
      colorBgMask: 'rgba(0, 0, 0, 0.45)',
      colorText: '#0C5787',
      colorIcon: '#0C5787',
      colorIconHover: '#80C0E9',
      paddingLG: 20,

      footerPaddingBlock: 16,
      footerPaddingInline: 24,

      titleFontSize: 20,
      titleLineHeight: 1.4,
      titleColor: '#FAFAFA',
      fontFamily: "'Oswald', sans-serif",
      fontWeight: 400
    },

    Card: {
      colorBgContainer: '#FFFFFF',
      colorBorderSecondary: 'transparent',
      borderRadiusLG: 10,
      boxShadow: 'none',
      boxShadowTertiary: '0 2px 8px rgba(51, 51, 51, 0.08)',

      paddingLG: 20,
      padding: 16,
      paddingSM: 12,

      headerHeight: 48,
      headerPadding: '0 24px',
      headerFontSize: 14,
      headerFontFamily: "'Oswald', sans-serif",
      headerFontWeight: 400,

      bodyPadding: '0 24px 16px 24px',

      actionsLiMargin: '12px 0',
      actionsBg: '#FAFAFA'
    },

    Table: {
      colorBgContainer: '#FFFFFF',
      colorText: '#0C5787',
      colorTextHeading: '#0C5787',

      headerBg: '#FAFAFA',
      headerColor: '#0C5787',
      headerSortActiveBg: '#F0F0F0',
      headerSortHoverBg: '#F0F0F0',
      headerSplitColor: 'transparent',

      rowHoverBg: '#E6F4FF',
      rowSelectedBg: '#E6F4FF',
      rowSelectedHoverBg: '#D9F0FF',
      bodySortBg: '#FAFAFA',

      borderColor: '#F0F0F0',
      headerBorderRadius: 8,

      cellPaddingBlock: 4,
      cellPaddingInline: 8,
      cellPaddingBlockMD: 3,
      cellPaddingInlineMD: 6,
      cellPaddingBlockSM: 2,
      cellPaddingInlineSM: 4,

      cellFontSize: 13,
      cellFontSizeMD: 12,
      cellFontSizeSM: 11,
      lineHeight: 1.3,

      footerBg: '#FAFAFA',
      footerColor: '#6B8799'
    },

    Tabs: {
      titleFontSize: 12,
      fontFamily: "'Oswald', sans-serif",
      fontSizeLG: 14,
      fontSizeSM: 12,

      colorText: '#6B8799',
      colorPrimary: '#80C0E9',
      itemColor: '#6B8799',
      itemSelectedColor: '#0C5787',
      itemHoverColor: '#80C0E9',
      itemActiveColor: '#0C5787',

      inkBarColor: '#80C0E9',

      cardBg: '#FFFFFF',
      cardGutter: 4,
      cardPadding: '8px 16px',
      cardPaddingSM: '6px 12px',
      cardPaddingLG: '10px 20px'
    },

    Menu: {
      colorBgContainer: '#0C5787',
      itemBg: '#0C5787',
      itemColor: '#FAFAFA',
      itemHoverColor: '#80C0E9',
      itemSelectedColor: '#FAFAFA',
      colorItemTextActive: '#80C0E9',

      itemHoverBg: 'rgba(128, 192, 233, 0.1)',
      itemSelectedBg: 'rgba(128, 192, 233, 0.15)',
      itemActiveBg: 'rgba(128, 192, 233, 0.2)',

      activeBarWidth: 5,
      activeBarHeight: '100%',
      activeBarBorderWidth: 5,

      subMenuItemBg: 'rgba(0, 0, 0, 0.05)',

      colorSplit: 'rgba(250, 250, 250, 0.2)',

      fontFamily: "'Oswald', sans-serif",
      fontWeight: 400,
      fontSize: 14,
      itemMarginBlock: 0,
      itemMarginInline: 0,
      itemPaddingInline: 16,
      itemBorderRadius: 0,
      subMenuItemBorderRadius: 0,

      iconSize: 16,
      iconMarginInlineEnd: 10,

      dangerItemColor: '#FAFAFA',
      dangerItemHoverColor: '#FAFAFA',
      dangerItemSelectedColor: '#FAFAFA',
      dangerItemActiveBg: '#B51010',
      dangerItemSelectedBg: '#B51010'
    },

    Dropdown: {
      colorBgElevated: '#FFFFFF',
      colorText: '#6B8799',
      borderRadiusLG: 8,
      boxShadowSecondary: '0 6px 16px rgba(0, 0, 0, 0.12)',

      controlItemBgHover: '#F0F0F0',
      controlItemBgActive: '#E6F4FF',
      controlItemBgActiveHover: '#E6F4FF',

      paddingBlock: 4,

      colorArrow: '#FFFFFF',
      colorArrowShadow: 'rgba(0, 0, 0, 0.12)'
    },

    Tag: {
      defaultBg: '#F0F0F0',
      defaultColor: '#6B8799',
      borderRadiusSM: 4,
      fontSizeSM: 12,
      lineHeightSM: 2,

      colorSuccess: '#439167',
      colorSuccessBg: '#F6FFED',
      colorSuccessBorder: '#B7EB8F',

      colorError: '#B51010',
      colorErrorBg: '#FFF2F0',
      colorErrorBorder: '#FFCCC7',

      colorWarning: '#E1B04F',
      colorWarningBg: '#FFFBE6',
      colorWarningBorder: '#FFE58F',

      colorInfo: '#80C0E9',
      colorInfoBg: '#E6F4FF',
      colorInfoBorder: '#91CAFF'
    },

    Descriptions: {
      labelBg: '#FAFAFA',
      titleColor: '#6B8799',
      colorText: '#0C5787',
      labelColor: '#333333',
      colorSplit: '#F0F0F0',
      itemPaddingBottom: 16,
      titleMarginBottom: 20,
      contentColor: '#0C5787',
      extraColor: '#6B8799',

      labelFontSize: 13,
      labelFontFamily: "'Oswald', sans-serif",
      labelLetterSpacing: '0.15em',
      labelTextTransform: 'uppercase',

      contentFontSize: 14,
      contentFontWeight: 600
    },

    Divider: {
      colorSplit: '#0C5787',
      colorText: '#0C5787',
      colorTextHeading: '#0C5787',
      marginLG: 24,
      margin: 16,
      orientationMargin: 0.05,
      verticalMarginInline: 8
    },

    Collapse: {
      contentBg: '#FAFAFA',
      contentPadding: '16px',
      headerBg: '#FFFFFF',
      headerPadding: '12px 16px',
      colorText: '#6B8799',
      colorTextHeading: '#333333',
      borderRadiusLG: 10,

      borderColor: '#E6EEF2',

      ghostContentBg: 'transparent'
    },

    Steps: {
      colorPrimary: '#80C0E9',
      colorText: '#6B8799',
      colorTextDescription: '#6B8799',
      colorTextDisabled: '#A5A3A3',
      colorSplit: '#E6EEF2',

      titleLineHeight: 1.5714,
      iconSize: 32,
      iconSizeSM: 24,
      iconFontSize: 16,
      dotSize: 8,
      dotCurrentSize: 10,

      colorPrimaryBorder: '#80C0E9',
      colorFillContent: '#0C5787',

      waitIconColor: '#B5BCC1',
      waitIconBgColor: '#FAFAFA',
      waitDotColor: '#B5BCC1',
      waitTitleColor: '#6B8799',
      waitDescriptionColor: '#A5A3A3',

      finishIconColor: '#0C5787',
      finishIconBorderColor: '#80C0E9',
      finishTitleColor: '#333333',

      navArrowColor: '#6B8799',
      navContentMaxWidth: 'auto'
    },

    Pagination: {
      colorPrimary: '#80C0E9',
      colorPrimaryHover: '#0C5787',
      colorText: '#6B8799',
      colorTextDisabled: '#A5A3A3',
      colorBgContainer: 'transparent',
      colorBgTextHover: '#F0F0F0',
      colorBgTextActive: '#E6F4FF',

      borderRadius: 6,
      itemSize: 32,
      itemSizeSM: 24,
      itemActiveBg: 'transparent',
      itemActiveBgDisabled: '#FAFAFA',
      itemBg: 'transparent',
      itemLinkBg: 'transparent',

      itemInputBg: '#FFFFFF'
    },

    Notification: {
      colorBgElevated: '#FFFFFF',
      colorText: '#333333',
      colorTextHeading: '#333333',
      colorIcon: '#80C0E9',
      colorIconHover: '#0C5787',
      borderRadiusLG: 8,
      boxShadow: '0 6px 16px rgba(0, 0, 0, 0.12)',
      width: 384,

      colorSuccess: '#439167',
      colorSuccessBg: '#F6FFED',
      colorSuccessBorder: '#B7EB8F',

      colorError: '#B51010',
      colorErrorBg: '#FFF2F0',
      colorErrorBorder: '#FFCCC7',

      colorWarning: '#E1B04F',
      colorWarningBg: '#FFFBE6',
      colorWarningBorder: '#FFE58F',

      colorInfo: '#80C0E9',
      colorInfoBg: '#E6F4FF',
      colorInfoBorder: '#91CAFF'
    },

    Message: {
      contentBg: '#FFFFFF',
      contentPadding: '10px 16px',
      colorText: '#333333',
      colorSuccess: '#439167',
      colorError: '#B51010',
      colorWarning: '#E1B04F',
      colorInfo: '#80C0E9',
      borderRadiusLG: 8,
      boxShadow: '0 6px 16px rgba(0, 0, 0, 0.12)'
    },

    Tooltip: {
      colorBgSpotlight: 'rgba(12, 87, 135, 0.92)',
      colorTextLightSolid: '#FFFFFF',
      borderRadius: 8,
      boxShadowSecondary: '0 6px 16px rgba(0, 0, 0, 0.12)',
      paddingSM: 8,
      paddingXS: 6
    },

    Popover: {
      colorBgElevated: '#FFFFFF',
      colorText: '#333333',
      borderRadiusLG: 8,
      boxShadowSecondary: '0 6px 16px rgba(0, 0, 0, 0.12)',
      titleMinWidth: 177,
      titleFontSize: 14,
      titleColor: '#333333'
    },

    Progress: {
      defaultColor: '#80C0E9',
      remainingColor: '#F0F0F0',
      circleTextColor: '#333333',
      lineBorderRadius: 100,

      colorSuccess: '#439167',
      colorSuccessBg: '#B7EB8F'
    },

    Spin: {
      colorPrimary: '#80C0E9',
      colorTextDescription: '#6B8799',
      contentHeight: 400
    },

    Result: {
      titleFontSize: 24,
      subtitleFontSize: 14,
      colorTextHeading: '#333333',
      colorTextDescription: '#6B8799',
      extraMargin: '24px 0 0 0',
      iconFontSize: 72,

      colorSuccess: '#439167',
      colorError: '#B51010',
      colorInfo: '#80C0E9',
      colorWarning: '#E1B04F'
    },

    Upload: {
      colorBgMask: 'rgba(0, 0, 0, 0.45)',
      colorText: '#6B8799',
      colorTextDescription: '#A5A3A3',
      colorTextHeading: '#333333',
      actionsColor: '#6B8799'
    },

    Tree: {
      colorBgContainer: '#FFFFFF',
      colorText: '#6B8799',
      directoryNodeSelectedBg: '#E6F4FF',
      directoryNodeSelectedColor: '#0C5787',
      nodeHoverBg: '#F0F0F0',
      nodeSelectedBg: '#E6F4FF',
      titleHeight: 24
    },

    List: {
      colorText: '#333333',
      colorTextDescription: '#6B8799',
      colorSplit: '#F0F0F0',
      itemPadding: '12px 0',
      itemPaddingSM: '8px 16px',
      itemPaddingLG: '16px 24px',

      metaMarginBottom: 0,
      avatarMarginRight: 16,
      titleMarginBottom: 4,
      descriptionFontSize: 14
    },

    Layout: {
      bodyBg: '#FAFAFA',
      headerBg: '#0C5787',
      headerColor: '#FAFAFA',
      headerHeight: 64,
      headerPadding: '0 24px',
      headerLineHeight: '64px',

      footerBg: '#D6DDE3',
      footerPadding: '24px 50px',

      siderBg: '#0C5787',
      triggerBg: '#0C5787',
      triggerColor: '#FAFAFA',
      triggerHeight: 48,
      zeroTriggerWidth: 36,
      zeroTriggerHeight: 42,

      lightSiderBg: '#FFFFFF',
      lightTriggerBg: '#FFFFFF',
      lightTriggerColor: '#6B8799'
    },

    Breadcrumb: {
      itemColor: '#FAFAFA',
      lastItemColor: '#FAFAFA',
      linkColor: '#FAFAFA',
      linkHoverColor: '#80C0E9',
      separatorColor: '#FAFAFA',
      separatorMargin: 8,
      fontSize: 14,
      iconFontSize: 14,
      fontFamily: "'PT Sans', sans-serif"
    },

    PageHeader: {
      colorText: '#FAFAFA',
      colorTextHeading: '#FAFAFA',
      colorBgContainer: 'transparent',
      paddingBlockLG: 16,
      paddingInline: 24,
      titleFontSize: 24,
      fontFamily: "'Oswald', sans-serif",
      fontWeight: 700
    },

    Skeleton: {
      colorFill: '#F0F0F0',
      colorFillContent: '#FAFAFA',
      gradientFromColor: 'rgba(0, 0, 0, 0.1)',
      gradientToColor: 'rgba(0, 0, 0, 0.05)',
      borderRadius: 4,
      borderRadiusLG: 8,
      borderRadiusSM: 2
    },

    Empty: {
      colorTextDescription: '#A5A3A3',
      colorTextDisabled: '#CBD1D4',
      fontSizeIcon: 64,
      marginXS: 8,
      marginXXS: 4
    },

    Alert: {
      colorText: '#333333',
      colorTextHeading: '#333333',
      withDescriptionIconSize: 24,

      colorSuccess: '#439167',
      colorSuccessBg: '#F6FFED',
      colorSuccessBorder: '#B7EB8F',

      colorError: '#B51010',
      colorErrorBg: '#FFF2F0',
      colorErrorBorder: '#FFCCC7',

      colorWarning: '#E1B04F',
      colorWarningBg: '#FFFBE6',
      colorWarningBorder: '#FFE58F',

      colorInfo: '#80C0E9',
      colorInfoBg: '#E6F4FF',
      colorInfoBorder: '#91CAFF'
    },

    Badge: {
      colorBgContainer: '#FFFFFF',
      colorBorderBg: '#FFFFFF',
      colorError: '#B51010',
      colorSuccess: '#439167',
      indicatorHeight: 20,
      indicatorHeightSM: 14,
      dotSize: 6,
      textFontSize: 12,
      textFontSizeSM: 12,
      textFontWeight: 400,
      statusSize: 6
    },

    Statistic: {
      titleFontSize: 14,
      contentFontSize: 24,
      unitFontSize: 16,
      colorText: '#333333',
      colorTextHeading: '#333333',
      colorTextDescription: '#6B8799',
      fontFamily: "'PT Sans', sans-serif"
    },

    Segmented: {
      borderRadius: 8,
      borderRadiusSM: 6,
      colorBgLayout: '#F0F0F0',
      colorText: '#6B8799',
      colorTextLabel: '#6B8799',
      itemColor: '#6B8799',
      itemSelectedBg: '#FFFFFF',
      itemSelectedColor: '#0C5787',
      itemHoverBg: 'rgba(0, 0, 0, 0.06)',
      itemHoverColor: '#80C0E9',
      itemActiveBg: '#FFFFFF',
      trackBg: '#FFFFFF',
      trackPadding: 4,
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
    }
  }
};
